import styled from "styled-components";
import { useLocation } from "react-router-dom";
import useInquriyDetail from "../../hooks/inquiry/useInquiryDetail";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";

function DContactView(){
    const id = useLocation().state;
    const {contact} = useInquriyDetail(id);
    const getImages = () => {
        if(!contact.file_list.length){
            return null;
        }
        return contact.file_list.map((item, index) => {
            return <Image src={item} key={index}/>
        })
    }
    return(
        <Container>
            <Header />
            <Contents>
                <div className="inner">
                    <InputWrap>
                        <InputText>{contact.register_at}</InputText>
                        <InputText>{contact.category}</InputText>
                    </InputWrap>
                    <InputText>{contact.content}</InputText>
                    {getImages()}
                    {contact.reply && 
                        <Reply>
                            <Label>답변</Label>
                            <TextArea >{contact.reply}</TextArea>
                        </Reply>
                    }
                </div>
            </Contents>
            <Footer />
        </Container>
    )
}

const Container = styled.div`
    width: 100vw;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

const Contents = styled.div`
    flex-grow: 1;
    margin-top: 160px;
    margin-bottom: 120px;
    width: 100%;
    .inner{
        display: flex;
        flex-direction: column;
        gap: 18px;
    }
`

const Label = styled.div`
`

const InputWrap = styled.div`
    display: flex;
    gap: 18px;
`

const InputText = styled.div`
    padding: 12px;
    border-radius: 2px;
    border: 1px solid #C7CCD2;
    background: #FFF;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
`

const TextArea = styled.div`
    padding: 12px;
    border-radius: 2px;
    background: #FFF;
    width: 100%;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 400;
`

const Image = styled.img`
`

const Reply = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: 20px;
    padding: 30px;
    background-color: #EBEBEB;
    animation-name: slideIn;
    animation-duration: 1s;
`

export default DContactView;